export class NavLinks {

    public static NAV_LINKS = [
        { url: '/account', text: 'Account Summary', icon: 'fa-info-circle' },
        { url: '/editcards', text: 'Edit Toll Passes', icon: 'fa-ticket' },
        { url: '/makepayment', text: 'Make Payment', icon: 'fa-credit-card' },
        { url: '/paymenthistory', text: 'Payment History' },
        { url: '/accountdetail', text: 'Trip History' },
        { url: '/renewalamount', text: 'Renewal Amount' },
        { url: '/changecurrency', text: 'Change Currency', hiddenOnCommercial: true, icon:'fa-usd' },
        { url: '/manageprofile', text: 'Manage Profile', children: [
            { url: '/mailing', text: 'Edit Mailing Address' },
            { url: '/billing', text: 'Edit Billing Address' },
            { url: '/credit' , text: 'Edit Credit Cards'}
          ], icon: 'fa-user'
        },
        { url: '/customerservice', text: 'Customer Service', icon: 'fa-question-circle' },

    ];

    public static CUSTOMER_SERVICE_LINKS = [
      { url: '/administration', text: 'Administration', children: [
          { url: '/notes', text: 'Account Notes' },
          { url: '/manage', text: 'Manage Customers' },
          { url: '/search', text: 'Link Customers' },
          { url: '/customer-service', text: 'Set Customer Service'},
          { url: '/manage-customer', text: 'New Manage Customer'}
        ]
      },
      { url: '/it', text: 'IT', children: [
          { url: '/customer-service', text: 'Customer Service' }
        ]
      }
    ];

    public static IT_LINKS = [
      { url: '/it', text: 'IT', children: [
          { url: '/customer-service', text: 'Customer Service' }
        ]
      }
    ];

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/nav-links.ts